import React from 'react';
import { connect } from 'react-redux';
import Logger from '../../util/Logger';
import '../shared/UserAvatar.css';
import './AccountAdministrators.css';
import User from '../../models/User';
import Admin from '../../models/User';
import { UserAvatar } from '../shared/UserAvatar';
import { removeAccountAdmin } from '../../actions/accountAdmins';
import { transferOwner } from '../../actions/accountOwner';
import { BaseDialog } from '../layout/Dialog';
import { handleErrorWithDialog } from '../../util/Errors';
import { RoleType } from '../../models/RoleType';
import { StringUtils } from '../../util/StringUtils';
import { showDialog } from '../../actions/dialog';
import Tenant from '../../models/Tenant';
import DateTime from '../../models/DateTime';
import { EnterpriseSettings } from '../../analytics/EnterpriseSettings';
import { PAGE_LINK_OWNER_ERROR } from '../../constants';

class AccountAdministratorListItem extends React.Component {

  handleOnRemoveClicked = (admin) => {
    EnterpriseSettings.removesAdmin();
    const { user, showDialog } = this.props;
    const email = Admin.getEmail(admin);
    const self = User.getEmail(user);
    // If we are attempting to remove ourselves, warn the user
    if (email && self && (email === self)) {
      showDialog({
        title: 'You are about to remove yourself as an Administrator',
        body: <div>Once you do this, you will lose access to the Enterprise Dashboard</div>,
        cancel: 'Cancel',
        ok: 'Ok',
        onOk: () => {
          EnterpriseSettings.removeSelfAdminOK();
          this.removeAdmin(email);
        },
        onCancel: () => {
          EnterpriseSettings.removeSelfAdminCancel();
        }
      });
    } else {
      this.removeAdmin(email);
    }
  };
  removeAdmin = (email) => {
    const { user, removeAccountAdmin } = this.props;
    if (email) {
      removeAccountAdmin(Tenant.getId(User.getTenant(user)), email);
    }
  };
  handleOnTransferClicked = () => {
    EnterpriseSettings.transferOwnership();
    EnterpriseSettings.transferOwnershipModal();
    this.setState({
      showTransferDialog: true,
      transferOwnerTo: ''
    });
  };
  handleOnTransferToChanged = ($event) => {
    this.setState({
      transferOwnerTo: $event.target.value || ''
    });
  };
  handleOnTransferSubmitted = ($event) => {
    if ($event) {
      $event.preventDefault();
    }

    // Do not dimiss the dialog until we are done here
    const { user, transferOwner, showDialog } = this.props;
    const emails = StringUtils.stringToList(this.state.transferOwnerTo);
    if (emails && emails.length === 1) {
      transferOwner(Tenant.getId(User.getTenant(user)), emails[0]);
    } else {
      showDialog({
        title: 'Cannot transfer Account ownership',
        body: <div>You must transfer ownership to a single valid email address.</div>,
        ok: 'Ok'
      });
    }

    return true;
  };
  hideDialog = () => {
    this.setState({
      showTransferDialog: false,
      transferOwnerTo: ''
    });
  };

  handleCallbackIfTransfer = (prevProps) => {
    const { user, transferringError } = this.props;
    if (!handleErrorWithDialog(transferringError, prevProps.transferringError,
      'Unable to transfer Ownership', {
        helpLink: PAGE_LINK_OWNER_ERROR
      })) {
      // Show the transfer error if it exists - but if we succeeded, do the thing.
      const { transferringOwner } = this.props;
      // Explicit false check here to see if the saga has run and been marked as completed
      // Falsey check will work wrongly since the boolean is falsey when nulled.
      if (User.getId(user) !== User.getId(Tenant.getOwner(User.getTenant(user))) &&
        transferringOwner === false &&
        transferringOwner !== prevProps.transferringOwner &&
        this.state.showTransferDialog) {
        this.hideDialog();

        // Delay a little before refreshing the page to re-trigger session check
        setTimeout(() => window.location.reload(), 1000);
      }
    }
  };

  constructor (props) {
    super(props);

    const { user, admin } = this.props;
    if (!user) {
      Logger.assert('Must pass an User model to AccountAdministratorListItem');
    }
    if (!admin) {
      Logger.assert('Must pass an AccountAdministrator model to AccountAdministratorListItem');
    }

    this.state = {
      showTransferDialog: false,
      transferOwnerTo: ''
    };
  }

  componentDidUpdate (prevProps) {
    const { admin } = this.props;
    if (isOrgOwner(getRole(admin))) {
      this.handleCallbackIfTransfer(prevProps);
    }
  }

  render () {
    const { user, admin, removeLoading, transferringOwner } = this.props;
    const { showTransferDialog, transferOwnerTo } = this.state;
    const name = Admin.getDisplayName(admin) || 'Not available';
    return (
      <div className="row admin-list-item list-item">
        <div className="name pr-2 font-size-sm">
          { name }
        </div>

        <div className="email pr-2 font-size-sm">
          <UserAvatar user={ admin } />
        </div>

        <div className="role font-size-sm">
          <OrganizationRole
            user={ user }
            admin={ admin }
            onTransferClicked={ this.handleOnTransferClicked } />
        </div>

        <div className="added font-size-sm">
          <AddedDate admin={ admin } />
        </div>

        <div className="remove font-size-sm">
          <Remove
            admin={ admin }
            onRemoveClicked={ this.handleOnRemoveClicked }
            disabled={ removeLoading } />
        </div>

        { showTransferDialog && <BaseDialog
          show={ showTransferDialog }
          title="Transfer Account Ownership"
          body={ (
            <div className="col no-gutters my-3">

              <div className="text-subtitle">
                Transfer to:
              </div>

              <form name="transferForm" className="col" onSubmit={ this.handleOnTransferSubmitted }>
                <input
                  type="text"
                  className="col no-gutters pop-input"
                  placeholder="Enter email address"
                  autoFocus={ true }
                  value={ transferOwnerTo }
                  onChange={ this.handleOnTransferToChanged } />
              </form>

              <div className="text-content mt-3">
                Your role will be changed to Admin.
              </div>

            </div>
          ) }
          ok="Transfer"
          onOk={ () => {
            if (!transferringOwner) {
              EnterpriseSettings.transferOwnershipModalOK();
              this.handleOnTransferSubmitted();
            }
            return true;
          } }
          cancel="Cancel"
          onCancel={ () => EnterpriseSettings.transferOwnershipModalCancel() }
          hideDialog={ this.hideDialog }
        /> }
      </div>
    );
  }

}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    transferringOwner: state.accountOwner.transferLoading,
    transferringError: state.accountOwner.transferError,
    removeLoading: state.accountAdmins.removeLoading
  };
};

const getRole = (admin) => {
  const role = User.getRoleType(admin);
  if (role === RoleType.USER) {
    Logger.assert('AccountAdministratorListItem got an role: USER');
  }
  return role;
};

const isOrgOwner = (role) => {
  return role === RoleType.ORG_OWNER;
};

export default connect(mapStateToProps, {
  removeAccountAdmin,
  transferOwner,
  showDialog
})(AccountAdministratorListItem);

/**
 * Display the admin role - also display a 'change' option for the tenant admin
 *
 * @param user current user session
 * @param admin AccountAdministrator object
 * @param onTransferClicked Admin transfer callback
 * @returns {*} JSX for OrganizationRole
 * @constructor admin object as named prop
 */
const OrganizationRole = ({ user, admin, onTransferClicked }) => {

  const handleOnTransferClicked = ($event, handle) => {
    $event.preventDefault();
    handle();
  };

  const displayRole = (role) => {
    switch (role) {
      case RoleType.POPIN_ADMIN:
        return 'Admin';
      case RoleType.ORG_ADMIN:
        return 'Admin';
      case RoleType.ORG_OWNER:
        return 'Owner';
      case RoleType.USER:
        return 'User';
      default:
        Logger.assert('Invalid user role: ', role);
    }
  };

  const role = getRole(admin);
  const isCurrentLoginUserOrgOwner = isOrgOwner(User.getRoleType(user));
  return (
    <div className="org-role row no-gutters">
      { displayRole(role) }
      { (isCurrentLoginUserOrgOwner && isOrgOwner(role)) && (
        <div
          className="change-role display-role"
          onClick={ e => handleOnTransferClicked(e, onTransferClicked) }>
          &nbsp; transfer
        </div>
      ) }
    </div>
  );
};

/**
 * Display the date the admin was added
 *
 * @param admin AccountAdministrator object
 * @returns {*} JSX for AddedDate
 * @constructor admin object as named prop
 */
const AddedDate = ({ admin }) => {
  const date = User.getAdminAddedDate(admin);
  return (
    <div className="added-date">
      { date ? DateTime.format(date, 'MMM DD, YYYY') : 'Not available' }
    </div>
  );
};

/**
 * Display the remove icon if the admin is not the tenant admin
 *
 * @param admin AccountAdministrator object
 * @param onRemoveClicked Admin removed callback
 * @param disabled Is this button disabled
 * @returns {*} JSX for Remove
 * @constructor admin object as named prop
 */
const Remove = ({ admin, onRemoveClicked, disabled }) => {

  const handleOnRemoveClicked = ($event, admin, handle) => {
    $event.preventDefault();
    handle(admin);
  };

  return (
    <button
      type="button"
      disabled={ disabled }
      onClick={ e => handleOnRemoveClicked(e, admin, onRemoveClicked) }
      className={ `remove btn btn-outline ${isOrgOwner(getRole(admin))
        ? ' invisible'
        : 'clickable' }` }>
      <i className="material-icons remove-icon">close</i>
    </button>
  );
};
